export enum VolunteerType {
    MISSION = 'mission',
    SKILL = 'skill',
}
